export type Dimensions = { width: number; height: number };

export const LU_PIN_DIMENSIONS: Dimensions = {
  width: 960,
  height: 540,
};
